import type { Detection } from 'src/models/extLandAiDetections';

export interface DetectionResponse {
  ts: string;
  contour_area_max: number;
  detection_transaction_id: number;
  detection_detail_view_group_id: number;
  detection_detail_id: number;
  img_ts: string;
  road_name_disp: string;
  direction: string;
  place_name: string;
  kp: string;
  lat: string;
  lon: string;
  detection_kind: string;
  img_path: string;
  contour_area_sum: number;
  angle: number | null;
  comment: string | null;
  detections_link: string;
  joint_types?: string;
}

export type DetectionsIndexResponse = DetectionResponse[];

export const toDetection = (response: DetectionResponse): Detection => ({
  ts: response.ts,
  contourAreaMax: response.contour_area_max,
  detectionTransactionId: response.detection_transaction_id,
  detectionDetailViewGroupId: response.detection_detail_view_group_id,
  detectionDetailId: response.detection_detail_id,
  imgTs: response.img_ts,
  roadNameDisp: response.road_name_disp,
  direction: response.direction,
  placeName: response.place_name,
  kp: response.kp,
  location: { lat: response.lat, lon: response.lon },
  detectionKind: response.detection_kind,
  imgPath: response.img_path,
  contourAreaSum: response.contour_area_sum,
  angle: response.angle,
  comment: response.comment,
  detectionsLink: response.detections_link,
  jointTypes: response.joint_types ?? null,
});
